import React from 'react';
import { DatePicker } from '../common';
import {
    CalendarMonth,
} from '@mui/icons-material';
import { FilterList, FilterListItem, FilterListItemIcon, FilterListItemText } from '../../utils';
import { SimpleFilter } from '../common/SimpleFilter';
import moment, { Moment } from 'moment';

interface Props {
    readonly styled: StyledProps;
    readonly before: null|Moment;
    readonly after: null|Moment;
    readonly onFilter: (
        before: null|Moment,
        after: null|Moment,
    ) => void;
}

interface State {
    readonly before: null|Moment;
    readonly after: null|Moment;
}

export class CheatersFilter extends React.Component<Props, State> {
    state: State = {
        before: null,
        after: null,
    };

    componentDidUpdate(prevProps: Props) {
        const {
            before,
            after,
        } = this.props;
        if ( prevProps.before === before &&
            prevProps.after === after
        ) {
            return;
        }

        this.setState({
            before,
            after,
        });
    }

    render() {
        const {
            before,
            after,
        } = this.state;

        const onFilterBefore = (before: Moment|null) => this.setState({ before });
        const onFilterAfter = (after: Moment|null) => this.setState({ after });

        const onFilter = () => {
            this.props.onFilter(
                before,
                after,
            );
        };

        const onClose = () => {
            this.setState({before: this.props.before, after: this.props.after});
        };

        return (
            <SimpleFilter
                styled={this.props.styled}
                title={'Filter Cheaters'}
                menuElement = {
                    <FilterList styled={this.props.styled}>
                        <FilterListItem
                            style={{minWidth: 350}}
                            styled={this.props.styled}
                            key={`after`}
                            secondaryAction={
                                <DatePicker
                                    onChange={onFilterAfter}
                                    value={after ?? moment(null)}
                                />
                            }
                        >
                            <FilterListItemIcon styled={this.props.styled}>
                                <CalendarMonth style={{ width: 18, height: 18 }} />
                            </FilterListItemIcon>
                            <FilterListItemText text={'After'} />
                        </FilterListItem>
                        <FilterListItem
                            style={{minWidth: 350}}
                            styled={this.props.styled}
                            key={`before`}
                            secondaryAction={
                                <DatePicker
                                    onChange={onFilterBefore}
                                    value={before ?? moment(null)}
                                />
                            }
                        >
                            <FilterListItemIcon styled={this.props.styled}>
                                <CalendarMonth style={{ width: 18, height: 18 }} />
                            </FilterListItemIcon>
                            <FilterListItemText text={'Before'} />
                        </FilterListItem>
                    </FilterList>
                }
                onFilter={onFilter}
                onClose={onClose}
            />
        );
    }
}
